import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function zoomin({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M10 3a7 7 0 104.192 12.606l5.1 5.101a1 1 0 001.415-1.414l-5.1-5.1A7 7 0 0010 3zm-5 7a5 5 0 1110 0 5 5 0 01-10 0z"
        clipRule="evenodd"
      />
      <path
        stroke="none"
        fillRule="evenodd"
        d="M10 7a1 1 0 00-1 1v1H8a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V8a1 1 0 00-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default zoomin;
